<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-haenigegeschaefte">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.HaengigeGeschaefte" | translate }}</h2>
  </ng-container>

  <div class="btn-group btn-group-sm float-end" data-toggle="buttons" titleActionButtons>
    <label [ngClass]="{ active: loadOption == 'HAENGIGE' }" class="btn btn-outline-secondary">
      <input
        (click)="setLoadOptions('HAENGIGE')"
        autocomplete="off"
        checked="loadOption == 'HAENGIGE'"
        class="btn-check"
        id="eigentuemer"
        name="rolle"
        type="radio" />
      {{ "HAENGIGE" | translate }}
    </label>
    <label [ngClass]="{ active: loadOption == 'ALLE' }" class="btn btn-outline-secondary">
      <input
        (click)="setLoadOptions('ALLE')"
        autocomplete="off"
        checked="loadOption == 'ALLE'"
        class="btn-check"
        id="uebrigeBerechtigte"
        name="rolle"
        type="radio" />
      {{ "ALLE" | translate }}
    </label>
  </div>
  @if (grundstueckEntry) {
    <cap-grundstueck-haengige
      [grundstueckId]="gsId"
      [hasRight]="grundstueckEntry?.permissions?.haengigeGeschaefte"
      [loadOption]="loadOption">
    </cap-grundstueck-haengige>
  }
</cap-rubrik>
